import { render, staticRenderFns } from "./ProductTabsDesktopInfo.vue?vue&type=template&id=c41c4c44&scoped=true&"
import script from "./ProductTabsDesktopInfo.vue?vue&type=script&lang=js&"
export * from "./ProductTabsDesktopInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductTabsDesktopInfo.vue?vue&type=style&index=0&id=c41c4c44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41c4c44",
  null
  
)

export default component.exports